import { render, staticRenderFns } from "./SavingsProducts.vue?vue&type=template&id=382d5fe6"
import script from "./SavingsProducts.vue?vue&type=script&lang=js"
export * from "./SavingsProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports